import { useRouter } from 'next/router';
import { useEffect } from 'react';

const Agency = () => {
  const router = useRouter();

  useEffect(() => {
    if (!router.query['agency']) return;

    router.replace({
      pathname: '/shared/[agency]',
      query: router.query,
    });
  }, [router]);

  return null;
};

export default Agency;
